import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./strategy-finder.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./strategy-finder.component.scss?ngResource";
import { Component } from "@angular/core";
import { AflaModuleStrategyService } from "../../services/afla-module-strategy/afla-module-strategy.service";
import { aflaModuleServiceProvider } from "../../services/afla-module-strategy/afla-module-strategy.service.provider";
let StrategyFinderComponent = class StrategyFinderComponent {
    moduleStrategyService;
    constructor(moduleStrategyService) {
        this.moduleStrategyService = moduleStrategyService;
    }
    ngOnInit() {
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService }
    ];
};
StrategyFinderComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-strategy-finder",
        providers: [aflaModuleServiceProvider],
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], StrategyFinderComponent);
export { StrategyFinderComponent };
